import { graphql, useStaticQuery } from "gatsby";

/**
 * useSiteMetadata is a custom hook that fetches the site's metadata using a GraphQL query.
 * The metadata includes the site's title, description, and URL.
 * @returns {object} An object containing the site's metadata.
 */
const useSiteMetadata = () => {
    // Use the useStaticQuery hook from Gatsby to fetch the site's metadata.
    const data = useStaticQuery(graphql`
        query {
            site {
                siteMetadata {
                    title
                    description
                    siteUrl
                    env
                    preview
                }
            }
        }
    `);

    // Return the site's metadata.
    return data.site.siteMetadata;
};

export default useSiteMetadata;
